import { useState } from "react";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "../lib/api";
import { Input } from "./ui/input";

export default function EmailCode({ email, code, setCode, error, children }) {
  const [busy, setBusy] = useState(false);
  const [sentTo, setSentTo] = useState("");
  const valid = /^[^\s@]+@[^\s@]+\.[a-z]{2,}$/i.test(email || "");
  const send = async () => {
    if (!valid) return toast.error("Enter a valid email first");
    setBusy(true);
    try { await api.post("/auth/email-code", { email }); setSentTo(email); toast.success(`Code sent to ${email}`); }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <div className="space-y-2" data-testid="email-code-box">
      <div className="flex gap-2 items-start">
        <div className="flex-1 min-w-0">{children}</div>
        <button type="button" data-testid="email-code-send" disabled={busy || !valid} onClick={send} className="px-4 h-12 rounded-full bg-white text-black text-sm font-semibold shrink-0 disabled:opacity-40">
          {busy ? <Loader2 size={14} className="animate-spin" /> : sentTo && sentTo === email ? "Resend" : "Send code"}
        </button>
      </div>
      {valid && <Input data-testid="email-code-input" inputMode="numeric" maxLength={6} placeholder={sentTo === email ? `6-digit code sent to ${email}` : "6-digit code (tap Send code)"} value={code} onChange={(e) => setCode(e.target.value.replace(/\D/g, ""))} className="h-11" />}
      {error && <p className="text-xs text-red-400" data-testid="email-code-error">{error}</p>}
    </div>
  );
}
